import { useEffect } from 'react'
import getEnv from './envUtils'

const favicons = {
  POP: require('@src/assets/images/favicons/favicon_POP.png'),
  SP: require('@src/assets/images/favicons/favicon_SP.png'),
}

export const useFavicon = (): void => {
  const { brand } = getEnv()
  useEffect(() => {
    let link = document.querySelector("link[rel~='icon']") as HTMLLinkElement
    if (!link) {
      link = document.createElement('link')
      link.rel = 'icon'
      document.getElementsByTagName('head')[0].appendChild(link)
    }
    link.href = brand === 'POP' ? favicons.POP : favicons.SP
  }, [brand])
}
